<template>
	<div class="warp">
		<div class="login">

			<div class="login-card">
				<h2 style="text-align: center;">
					<p style="border-bottom: 2px solid #0052D9;display: inline-block;line-height: 50px;">{{btnText}}</p>
				</h2>
				<div class="card-body" v-if="longinType == 'code'">
					<div ref="dragDiv" style="margin-bottom: 15px;font-size: 18px;" class="drag">
					    <div class="drag_bg"></div>
					    <div class="drag_text">{{ confirmWords }}</div>
					    <div ref="moveDiv" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg"
					         style="position: absolute;top: 0px;left: 0px;" @mousedown="mousedownFn($event)"></div>
					</div>
					<div class="card-inp">
						<input type="text" placeholder="请输入手机号" v-model.trim="form1.phone">
					</div>
					<div class="card-yz">
						<div class="card-inp" style="flex: 1;">
							<input type="text" placeholder="请输入验证码" v-model.trim="form1.code">
						</div>
						<!-- <div class="inp-yz" @click="" :class="{grey:isGrey,blue:!isGrey}" :disabled="dis"
							@click="getCode">
							<span v-if="show">发送验证码</span>
							<span v-else>重新发送({{count}}s)</span>
						</div> -->
						<div  
						    class="inp-yz"  
						    @click="getCode"  
						    :class="{ grey: isGrey, blue: !isGrey }"  
						    :style="{ pointerEvents: isDisabled ? 'none' : 'auto' }"  
						  >  
						    <span v-if="show">发送验证码</span>  
						    <span v-else>重新发送({{ count }}s)</span>  
						</div>  
					</div>
					<div class="login-type">
						<span @click="$router.push('/forget')">忘记密码？</span>
						<span @click="changeLoginType('pwd')">密码登陆</span>
					</div>
					<div class="login-btn" @click="codeLogin">
						{{btnText}}
					</div>
				</div>
				<div class="card-body" v-if="longinType == 'pwd'">
					<div class="card-inp">
						<input type="text" placeholder="请输入手机号或邮箱" v-model.trim="formPwd.account">
					</div>
					<div class="card-inp">
						<input type="password" placeholder="请输入密码" v-model.trim="formPwd.pwd">
					</div>
					<div class="card-yz">
						<div class="card-inp" style="flex: 1;">
							<input type="text" placeholder="请输入验证码" v-model.trim="formPwd.code">
						</div>
						<div class="inp-yz" @click="getYzImg">
							<img :src='yzImg' alt="" style="width: 100%;height: 100%;">
						</div>
					</div>
					<div class="login-type">
						<span @click="$router.push('/forget')">忘记密码？</span>
						<span @click="changeLoginType('code')">验证码登录</span>
					</div>

					<div class="login-btn" @keydown.enter="pwdLogin" @click="pwdLogin">
						{{btnText}}
					</div>
				</div>
				<div class="card-body" v-if="longinType == 'scanCode'">
					<div style="display: flex;align-items: center;justify-content: center;padding: 20px;">
						<img src='../../assets/logo.png' alt="">
					</div>
					<div class="login-type">
						<span @click="$router.push('/forget')">忘记密码？</span>
						<span @click="changeLoginType('pwd')">密码登陆</span>
					</div>
				</div>
				<div class="card-bottom">
					<div class="card-bottom-header">
						<div></div>
						<p>第三方登录</p>
						<div></div>
					</div>
					<div class="card-bottom-boday">
						<div>
							<img src="../../assets/images/wechat.png" @click="wechatLogin" alt="">
						</div>
						<div>
							<img src="../../assets/images/aliPay.png" @click="alipayLogin" alt="">
						</div>
						
					</div>
				</div>
				<div class="card-footer">
					还没有账号？<span @click="$router.replace('/register')">快速注册</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isDisabled: false, // 控制div是否可点击  
				blue: true,  
				beginClientX: 0, /* 距离屏幕左端距离 */
				mouseMoveStata: false, /* 触发拖动状态  判断 */
				maxwidth: '', /* 拖动最大宽度，依据滑块宽度算出来的 */
				confirmWords: '请先拖动滑块进行人机验证', /* 滑块文字 */
				confirmSuccess: false, /* 验证成功判断 */
				nextStep: false,
				longinType: 'code',
				dis: false,
				show: true,
				isGrey: false, //按钮样式
				timer: null, //设置计时器,
				count: "",
				form1: {
					phone: '',
					code: ''
				},
				formPwd: {
					account: '',
					code: '',
					pwd: ''
				},
				serverCode: 1234,
				yzImg: '',
				yzuniqid: '',
				alipayUserId: '',
				btnText: '登录',
				bindType: '',
				wechatUserId: ''
			}
		},
		mounted () {
		      this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
		      document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn);
		      document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn)
		    },
		created() {
			this.alipayCheckReg()
			this.wechatCheckReg()
			this.getYzImg()
			var _this = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key == 13) {
					if (_this.longinType == 'pwd') {
						_this.pwdLogin();
					} else {
						_this.codeLogin();
					}
				}
			};

		},
		destroyed() {
			document.onkeydown = null
		},
		watch: {
			'$route': {
				handler(n, o) {
					console.log(n, o);
				},
				immediate: true
			}
		},
		methods: {
			
			async wechatCheckReg() {
				if (this.$route.query.code) {
					this.bindType = 'wechat'
					let log = await this.$api.getWechatCode({
						code: this.$route.query.code
					})
					console.log(log);
					if (log.data.openid) {
						const bind = await this.$api.wechatCheckBind({
							open_id: log.data.openid
						})
						if (bind.code == 0) {
							this.$message({
								message: '请绑定手机号',
								type: 'error',
								duration: 5000
							});
							this.wechatUserId = log.data.openid
							this.btnText = '绑定'
						} else {
							bind.data.userinfo.login = true
							this.$store.commit('SET_UserInfo', bind.data.userinfo)
							sessionStorage.setItem('userInfo', JSON.stringify(bind.data.userinfo));
							sessionStorage.setItem('token', bind.data.userinfo.token);
							if (bind.data.userinfo.guidance_status == 0) {
								this.$router.replace('/userCenterShow')
							} else {
								this.$router.replace('/userCenter')
							}
						}
					} else {
						this.$message({
							message: '授权失败',
							type: 'error'
						});

					}
				} else {
					return
				}
			},
			async alipayCheckReg() {
				if (this.$route.query.auth_code) {
					this.bindType = 'alipay'
					let log = await this.$api.alipayLogin({
						auth_token: this.$route.query.auth_code
					})
					if (log.code == 1) {
						const bind = await this.$api.alipayCheckBind({
							alipay_user_id: log.data.user_id
						})
						if (bind.code == 0) {
							this.$message({
								message: '请绑定手机号',
								type: 'error',
								duration: 5000
							});
							this.alipayUserId = log.data.user_id
							this.btnText = '绑定'
						} else {
							bind.data.userinfo.login = true
							this.$store.commit('SET_UserInfo', bind.data.userinfo)
							sessionStorage.setItem('userInfo', JSON.stringify(bind.data.userinfo));
							sessionStorage.setItem('token', bind.data.userinfo.token);
							if (bind.data.userinfo.guidance_status == 0) {
								this.$router.replace('/userCenterShow')
							} else {
								this.$router.replace('/userCenter')
							}
						}
					}
				} else {
					return
				}
			},
			mousedownFn: function (e) {
			        if (!this.confirmSuccess) {
			          e.preventDefault && e.preventDefault(); // 阻止文字选中等 浏览器默认事件
			          this.mouseMoveStata = true;
			          this.beginClientX = e.clientX;
			        }
			      },
			      // mousedoen 事件
			      successFunction () {
					this.isDisabled = false; // 使div可点击  
			        this.confirmSuccess = true
			        this.confirmWords = '验证通过';
			        if (window.addEventListener) {
			          document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn);
			          document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn);
			        } else {
			          document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => {});
			        }
			        document.getElementsByClassName('drag_text')[0].style.color = '#fff'
			        document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
			        document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
			      },
			      // 验证成功函数
			      mouseMoveFn (e) {
			        if (this.mouseMoveStata) {
			          let width = e.clientX - this.beginClientX;
			          if (width > 0 && width <= this.maxwidth) {
			            document.getElementsByClassName('handler')[0].style.left = width + 'px';
			            document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
			          } else if (width > this.maxwidth) {
			            this.successFunction();
			          }
			        }
			      },
			      // mousemove事件
			      moseUpFn (e) {
			        this.mouseMoveStata = false;
			        var width = e.clientX - this.beginClientX;
			        if (width < this.maxwidth) {
			          document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
			          document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
			        }
				},
			// msgMobileLogin
			alipayLogin() {
				location.href =
					'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021004116690108&scope=auth_user&redirect_uri=https%3a%2f%2fwww.zhaowaixie.com%2f%23%2flogin';
			},
			wechatLogin() {
				location.href =
					'https://open.weixin.qq.com/connect/qrconnect?appid=wx4658885ebd2e3204&redirect_uri=https%3a%2f%2fwww.zhaowaixie.com%2f%23%2flogin&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect'
			},
			async getYzImg() {
				const code = await this.$api.verifyCode()
				this.yzImg = code.data.src
				this.yzuniqid = code.data.uniqid
				// console.log(code);
			},
			changeLoginType(type) {
				this.longinType = type
				this.form1.phone = ''
				this.form1.code = ''
				this.formPwd.account = ''
				this.formPwd.code = ''
				this.formPwd.pwd = ''
			},
			async codeLogin() {
				let login
				if (this.alipayUserId && this.bindType == 'alipay') {
					if (this.verificationCode()) {
						login = await this.$api.alipayBindAccount({
							alipay_user_id: this.alipayUserId,
							mobile: this.form1.phone,
							captcha: this.form1.code
						})
					}
				} else if (this.wechatUserId && this.bindType == 'wechat') {
					if (this.verificationCode()) {
						login = await this.$api.bindWechatAccount({
							open_id: this.wechatUserId,
							mobile: this.form1.phone,
							captcha: this.form1.code
						})
					}
				} else {
					if (this.verificationCode()) {
						login = await this.$api.msgMobileLogin({
							mobile: this.form1.phone,
							captcha: this.form1.code
						})

					}
				}
				if (login.code == 1) {
					this.$message({
						message: login.msg,
						type: 'success'
					});
					login.data.userinfo.login = true
					this.$store.commit('SET_UserInfo', login.data.userinfo)
					sessionStorage.setItem('userInfo', JSON.stringify(login.data.userinfo));
					sessionStorage.setItem('token', login.data.userinfo.token);
					if (login.data.userinfo.guidance_status == 0) {
						this.$router.replace('/userCenterShow')
					} else {
						this.$router.replace('/userCenter')
					}
				} else {
					this.$message({
						message: login.msg,
						type: 'error'
					});
				}
				// this.$router.push('/userCenterShow')
			},
			async pwdLogin() {
				if (this.verificationPwd()) {
					const login = await this.$api.mobileEmailLogin({
						account: this.formPwd.account,
						password: this.formPwd.pwd,
						code: this.formPwd.code,
						uniqid: this.yzuniqid
					})
					this.getYzImg()
					console.log(login.code);
					if (login.code == 1) {
						this.$message({
							message: login.msg,
							type: 'success'
						});
						login.data.userinfo.login = true
						this.$store.commit('SET_UserInfo', login.data.userinfo)
						sessionStorage.setItem('userInfo', JSON.stringify(login.data.userinfo));
						sessionStorage.setItem('token', login.data.userinfo.token);
						if (login.data.userinfo.guidance_status == 0) {
							this.$router.replace('/userCenterShow')
						} else {
							this.$router.replace('/userCenter')
						}
					} else {
						this.$message({
							message: login.msg,
							type: 'error'
						});
					}
				}
			},

			verificationPwd() {
				if (this.formPwd.account === "" || this.formPwd.code === "" || this.formPwd.pwd === "") {
					this.$message.error('请填写完整信息');
					return false;
				}
				const emailReg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
				// 正则表达式，匹配以 1 开头的 11 位数字
				const phoneReg = /^1\d{10}$/;
				if (this.formPwd.account.indexOf('@') > -1) {
					if (!emailReg.test(this.formPwd.account)) {
						this.$message.error('请输入正确的账号');
						return false;
					}
				} else {
					if (!phoneReg.test(this.formPwd.account)) {
						this.$message.error('请输入正确的账号');
						return false;
					}
				}
				if (this.formPwd.pwd.length < 6) {
					this.$message.error('密码不小于6位');
					return false;
				}

				return true
			},
			verificationCode() {
				if (this.form1.phone === "") {
					this.$message.error('请填写手机号');
					return false;
				}
				var phoneReg = /^1\d{10}$/;
				if (!(phoneReg.test(this.form1.phone))) {
					this.$message.error('手机号格式不正确，请重新输入！');

					return false;
				}
				return true
			},
			async getCode() {
				if(!this.confirmSuccess){
					this.$message.error('请先拖动滑块进行人机验证！');
					return;
				}
				let TIME_COUNT = 60;
				const phoneRegex = /^1\d{10}$/;
				if (phoneRegex.test(this.form1.phone)) {
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.isGrey = true;
						this.show = false;
						this.dis = true;
						const yzcode = await this.$api.sendPhoneCode({
							mobile: this.form1.phone
						})
						console.log(yzcode.code);
						if (yzcode.code == 1) {
							this.$message({
								message: yzcode.msg,
								type: 'success'
							});
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.dis = false;
									this.isGrey = false;
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000);
						} else {
							this.$message({
								message: yzcode.msg,
								type: 'warning'
							});
						}
					}
				} else {
					this.$message.error('手机号式错误');
				}	
			},
		}
	}
</script>
<style scoped>
	.drag{
	        position: relative;
	        background-color: #e8e8e8;
	        width: 100%;
	        height: 34px;
	        line-height: 34px;
	        text-align: center;
	    }
	    .handler{
	        width: 40px;
	        height: 32px;
	        border: 1px solid #ccc;
	        cursor: move;
	    }
	    .handler_bg{
	        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
	    }
	    .handler_ok_bg{
	        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
	    }
	    .drag_bg{
	        background-color: #7ac23c;
	        height: 34px;
	        width: 0px;
	    }
	    .drag_text{
	        position: absolute;
	        top: 0px;
	        width: 100%;text-align: center;
	        -moz-user-select: none;
	        -webkit-user-select: none;
	        user-select: none;
	        -o-user-select:none;
	        -ms-user-select:none;
	    }

	.card-footer {
		font-size: 14px;
		color: #888888;
		line-height: 50px;
		text-align: center;
		position: absolute;
		width: 100%;
		bottom: 0;
		height: 50px;
		background: #EEEEEE;
		border-radius: 0px 0px 5px 5px;
	}

	.card-footer>span {
		color: #0052D9;
		cursor: pointer;
	}

	.card-bottom-boday {
		margin-top: 40px;
		display: flex;
		justify-content: space-around;
	}

	.card-bottom-boday>div>img {
		cursor: pointer;
		width: 50px;
		height: 50px;
	}

	.card-bottom {
		box-sizing: border-box;
		margin-top: 15px;
		padding: 0 70px;
		margin-bottom: 70px;
	}

	.card-bottom-header {
		display: flex;
		width: 100%;
		font-size: 14px;
		justify-content: space-between;
		align-items: center;
		color: #888888;
	}

	.card-bottom-header>div {
		height: 1px;
		width: 115px;
		background: #DCDCDC;
	}

	.login-btn {
		color: white;
		line-height: 60px;
		margin-top: 15px;
		text-align: center;
		height: 60px;
		cursor: pointer;
		background: #0052D9;
	}

	.login-type {
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		color: #888888;
		margin-top: 30px;
	}

	.login-type>span:hover {
		color: #0052D9;
		cursor: pointer;
	}

	.grey {
		background-color: #EDEEF1;
		border-color: #EDEEF1;
		color: #666;
		width: 30%;
	}

	.blue {
		background-color: #64A0DD;
		border-color: #64A0DD;
	}

	.inp-yz {
		cursor: pointer;
		width: 160px;
		height: 55px;
		background: #E5EDFB;
		margin-left: 8px;
		color: #0052D9;
		line-height: 55px;
		text-align: center;
	}

	.card-yz {
		display: flex;
	}

	.card-inp>input {
		font-size: 18px;
		margin-left: 20px;
		width: 100%;
	}

	.card-inp {
		margin-bottom: 15px;
		font-size: 18px;
		height: 55px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.card-body {
		padding: 35px;
		box-sizing: border-box;
	}

	.login {
		padding-top: 80px;
	}

	.login-card>h2 {
		border-bottom: 1px solid #E5E5E5;

	}

	.login-card {
		position: relative;
		margin: 0 auto;
		box-sizing: border-box;
		padding-top: 20px;
		width: 480px;
		background: #FFFFFF;
		border: 1px solid #E7E7E7;
		box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.16);
		border-radius: 5px;
	}

	.warp {
		background: url('../../assets/images/loginBG.png') no-repeat;
		background-size: cover;
		width: 100%;
		height: 850px;
	}
</style>